import apiClient from "../../../service/apiClient";
import { IP_SETTINGS_ENDPOINTS } from "../../../app/apiEndpoints";

export const getIPSettings = () => {
    return apiClient.get(IP_SETTINGS_ENDPOINTS.GET_IP_SETTINGS)
}

export const insertOrUpdateIPSettings = (data) => {
    return apiClient.post(IP_SETTINGS_ENDPOINTS.INSERT_OR_UPDATE_IP_SETTINGS,data)
}

export const deleteIPSettings = (data) => {
    return apiClient.post(IP_SETTINGS_ENDPOINTS.DELETE_IP_SETTINGS,data)
}